import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import get from 'lodash/get';
import has from 'lodash/has';
import { CHANNEL_COMPONENTS } from '../../../constants';
import { useDevicesByChannel } from './hooks';
import BluetoothPin from './BluetoothPin';
import BluetoothPairingInstruction from './BluetoothPairingInstruction';
import ChooseConnection from './ChooseConnection';
import ConnectBlueCable from './ConnectBlueCable';
import ConnectBluetooth from './ConnectBluetooth';
import ConnectUsb from './ConnectUsb';
import InstallBlueCableDrivers from './InstallBlueCableDrivers';
import InstallingBlueCableDrivers from './InstallingBlueCableDrivers';
import InstalledBlueCableDrivers from './InstalledBlueCableDrivers';
const components = {
    BluetoothPin,
    BluetoothPairingInstruction,
    ChooseConnection,
    ConnectBlueCable,
    ConnectBluetooth,
    ConnectUsb,
    InstallBlueCableDrivers,
    InstallingBlueCableDrivers,
    InstalledBlueCableDrivers
};
const Connect = ({ selectedChannel, onSetComponent, onSetStyleModifier, onSetChannel })=>{
    const devicesByChannel = useDevicesByChannel();
    const defaultComponentName = CHANNEL_COMPONENTS[selectedChannel] || 'ChooseConnection';
    const [componentName, setComponentName] = useState(defaultComponentName);
    const Component = get(components, componentName, null);
    const onSetComponentName = (newComponentName)=>{
        if (!has(components, newComponentName)) {
            onSetComponent(newComponentName);
            return;
        }
        setComponentName(newComponentName);
    };
    return /*#__PURE__*/ _jsx(Component, {
        selectedChannel: selectedChannel,
        devicesByChannel: devicesByChannel,
        onSetComponent: onSetComponentName,
        onSetStyleModifier: onSetStyleModifier,
        onSetChannel: onSetChannel
    });
};
export default Connect;
